const isAbsoluteUrl = (value: string) => /^https?:\/\//i.test(value);

const getBaseOrigin = () => {
  const baseUrl = process.env.REACT_APP_Base_URL || "";
  if (!baseUrl) return "";
  try {
    return new URL(baseUrl).origin;
  } catch {
    return "";
  }
};

export const resolveMediaUrl = (value?: string | null) => {
  if (!value) return "";
  if (isAbsoluteUrl(value)) return value;
  const baseOrigin = getBaseOrigin();
  if (!baseOrigin) return value;
  return `${baseOrigin}${value.startsWith("/") ? value : `/${value}`}`;
};

export const getCvViewUrl = (value?: string | null) => {
  const url = resolveMediaUrl(value);
  if (!url) return "";

  if (url.includes("cloudinary.com")) {
    return url
      .replace(/\/fl_attachment[^/]*\//g, "/")
      .replace(/\/fl_inline[^/]*\//g, "/");
  }

  return url;
};
